export default "<button (click)=\"buscarLocalesConPais()\">Log de locales de Chile con ciudad Providencia, Vitacura, Las Condes y\n    Santiago</button>";